import Service from '../../../service/api';

const v4Module = {
  namespaced: true,
  state: {
    v4DataStack: [],
    v4CurrentMainCodeItem: null,
    v4MainType: null,
    v4MainContent: null,
    v4Pages: 0,
  },
  mutations: {
    addPayloadStack(state, data) {
      //compare and add
      const index = state.v4DataStack.findIndex(
        (item) => item.codeItem === data.codeItem
      );

      if (index !== -1) {
        // console.log('found existing overwrite');
        //overwrite existed one
        const updatedItem = { ...state.v4DataStack[index], ...data };
        state.v4DataStack.splice(index, 1, updatedItem);
      } else {
        // console.log('add new to data stack');
        //add new
        state.v4DataStack.push(data);
      }
    },
    clearPayloadStack(state) {
      //clear vuex storage
      state.v4DataStack = [];
    },

    setV4StateCurrent(state, data) {
      state.v4CurrentMainCodeItem = data.mainCodeItem;
      state.v4MainType = data.mainType;
      state.v4MainContent = data.mainContent;
      state.v4Pages = data.pages;
    },
  },
  actions: {
    v4ProgressAndScoreCalc({ commit, dispatch, state, rootState }, payload) {
      //calculate payload
      const progressPercent =
        payload.pages > 0
          ? (payload.dataStack.length / payload.pages) * 100
          : 0;

      const totalProgressCalc = Number(progressPercent.toFixed(2));
      //calc score
      let scoreCalc = 0;

      // if (payload.dataStack.length === 0) {
      //   scoreCalc = 0;
      // } else {
      //   //if score is more than 10

      //   for (let i = 0; i < payload.dataStack.length; i++) {
      //     const item = payload.dataStack[i];

      //     //if item.score is shown in obj
      //     //if item.score more than 0 just plus into scoreCalc

      //     if (item.score !== undefined && item.score > 0) {
      //       scoreCalc += item.score;
      //     }
      //     //if not have score in obj calculate nothing
      //   }
      // }

      if (Array.isArray(payload.dataStack)) {
        payload.dataStack.forEach((item, index) => {
          // 1. เช็คว่ามี key score และค่าไม่ใช่ null/undefined
          if (
            Object.prototype.hasOwnProperty.call(item, 'score') &&
            item.score !== null
          ) {
            const p = Number(item.score); // บังคับเป็นตัวเลข

            if (!isNaN(p) && p > 0) {
              scoreCalc += p;
            }
          }
        });
      }
      //2408101 ch1 ,2408102

      const courseCode = rootState.necessary.courseCode;
      //ch1

      if (courseCode === '24081001') {
        //for chinese 1
        if (payload.mainType === 'test') {
          //check scoreClac
          if (scoreCalc > 20) {
            scoreCalc = 20;
          }
        } else if (
          payload.mainType === 'pretest' ||
          payload.mainType === 'posttest'
        ) {
          if (scoreCalc > 50) {
            scoreCalc = 50;
          }
        }
      } else if (courseCode === '24081002') {
        //for chinese 2
        //check state main type
        if (payload.mainType === 'test' || payload.mainType === 'assignment') {
          //check scoreClac
          if (scoreCalc > 10) {
            //give 10
            scoreCalc = 10;
          }
        } else if (
          payload.mainType === 'pretest' ||
          payload.mainType === 'posttest'
        ) {
          if (scoreCalc > 30) {
            scoreCalc = 30;
          }
        }
      }

      const newData = {
        ...payload,
        totalProgress: totalProgressCalc,
        totalScore: scoreCalc,
      };

      if (payload.type == 'SCORE') {
        //only save score on score page
        dispatch('v4SaveScoreOnly', newData);
      } else {
        dispatch('v4SaveContent', newData);
      }
    },
    async v4SaveContent({ commit, dispatch, state }, payload) {
      // console.log(payload, 'send save Content run');
      try {
        const res = await Service.v4SaveContent(payload);

        console.log('save complete', payload);
        commit('clearPayloadStack');
        commit('setV4StateCurrent', payload);

        commit('v4-data/stampCurrentMainCodeItem', res.data.data, {
          root: true,
        });
      } catch (error) {
        console.log('Error save content v4', error);
      }
    },
    processItemData({ commit, dispatch, state }, payload) {
      if (payload.dataStack && payload.dataStack.length > 0) {
        // on these type will not save if it' close before finished
        if (
          payload.mainType == 'assignment' ||
          payload.mainType == 'test' ||
          payload.mainType == 'pretest' ||
          payload.mainType == 'posttest'
        ) {
          //these mainType not save just clear storage
          commit('clearPayloadStack');
          //commit to response for redirect
          commit('v4-data/stampCurrentMainCodeItem', 'clear', {
            root: true,
          });
          console.log('stack clear due to unfinished task');
        } else {
          dispatch('v4ProgressAndScoreCalc', payload);
        }
      }
    },
    checkCurrentMainCode({ commit, dispatch, state, rootState }, payload) {
      //set state ที่เข้ามาใหม่
      commit('setV4StateCurrent', {
        mainCodeItem: payload.mainCodeItem,
        mainType: payload.mainType,
        mainContent: payload.mainContent,
        pages: payload.pages,
      });
      //ถ้า maincodeItem หน้านี้ ไม่เท่ากับ currentMainCode
      const isNewItem = payload.mainCodeItem !== state.v4CurrentMainCodeItem;

      if (isNewItem) {
        //save
        dispatch('processItemData', {
          ...payload,
          dataStack: state.v4DataStack,
          courseId: rootState.v3.v3EnrollData.data.courseinfo,
          section: rootState.v3.v3EnrollData.data.section,
        });
      }
    },

    async v4SaveScoreOnly({ commit, dispatch, state }, payload) {
      try {
        const res = await Service.v4SaveContent(payload);
        console.log(payload, 'save score done');

        commit('setV4StateCurrent', payload);

        commit('v4-data/saveScoreOnlyv4', res.data.data, {
          root: true,
        });
      } catch (error) {
        console.log('Error save score v4', error);
      }
    },
    stampCurrentScore({ commit, dispatch, state, rootState }, payload) {
      //only stamp score
      const currentStack = [...state.v4DataStack];

      const newData = {
        mainCodeItem: payload.mainCodeItem,
        mainType: payload.mainType,
        mainContent: payload.mainContent,
        dataStack: currentStack,
        pages: payload.pages,
        courseId: rootState.v3.v3EnrollData.data.courseinfo,
        section: rootState.v3.v3EnrollData.data.section,
        type: 'SCORE',
      };

      dispatch('v4ProgressAndScoreCalc', newData);
    },
    forceSavePayload({ commit, dispatch, state, rootState }, payload) {
      //check mainType first
      //for only main page
      if (
        payload.mainType == 'assignment' ||
        payload.mainType == 'test' ||
        payload.mainType == 'pretest' ||
        payload.mainType == 'posttest'
      ) {
        //these mainType not save just clear storage
        commit('clearPayloadStack');
        //commit to response for redirect
        commit('v4-data/stampCurrentMainCodeItem', 'clear', {
          root: true,
        });
        console.log('stack clear due to unfinished task');
      } else {
        dispatch('v4ProgressAndScoreCalc', payload);
      }
    },
  },
  getters: {},
};

export default v4Module;
